import Icon from '../components/Icon.vue'

Icon.register({
  'fire-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M323.6 51.2c72.5 67.3 124.4 177.1 124.4 230.4 0 127.3-100.3 230.4-224 230.4s-224-103.2-224-230.4c0-71.6 69.7-190.4 168-281.6 38.3 35.5 72.1 73.6 99.3 111.2 16.6-20.4 35.4-40.7 56.2-60zM304.1 391.8c49.2-34.4 60.8-101.2 33.4-153.4-3.4-6.4-7.1-13.1-11.3-20l-58.6 66.9s-91.9-117.4-98.8-125.3c-48.5 58.1-72.8 92.1-72.8 130.8 0 77.5 58.7 125.3 130.9 125.3 28.9 0 55.6-9 77.2-24.2z'
      }
    ]
  }
})
